import { useMutation } from 'react-query';
import { ProjectMilestonesApi } from '../../../api/ProjectApi/ProjectMilestonesApi';
import { useInvalidateProjectMilestones } from './useProjectMilestones';

export const useProjectMilestoneEdit = () => {
  const invalidateMilestones = useInvalidateProjectMilestones();

  return useMutation(ProjectMilestonesApi.patchProjectMilestone, {
    onSuccess: (_, input) => {
      invalidateMilestones(input.projectUid);
    },
  });
};
